"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireWildcard(require("@pds-react/icon"));

var _excluded = ["id", "type", "iconLeft", "iconRight", "hasError", "ariaDescribedBy", "size"],
    _excluded2 = ["id", "label", "className", "type", "errorMessage", "helperText", "iconLeft", "iconRight", "required", "optional", "size"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** Text inputs are form elements that allow a user to enter text. */
var IconInput = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  /* eslint-disable react/prop-types */
  var id = props.id,
      type = props.type,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      hasError = props.hasError,
      ariaDescribedBy = props.ariaDescribedBy,
      size = props.size,
      otherProps = _objectWithoutProperties(props, _excluded);
  /* eslint-enable react/prop-types */


  var wrapperClasses = (0, _classnames["default"])({
    "pds-input-icon-left": iconLeft,
    "pds-input-icon-right": iconRight
  });
  var inputClasses = (0, _classnames["default"])({
    "pds-input-error": hasError,
    "pds-input-small": size === "small"
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: wrapperClasses
  }, iconLeft && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: iconLeft
  }), iconRight && /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    name: iconRight
  }), /*#__PURE__*/_react["default"].createElement("input", _extends({
    type: type,
    id: id,
    ref: ref,
    className: inputClasses,
    "aria-invalid": hasError ? "true" : false,
    "aria-describedby": // eslint-disable-next-line react/prop-types
    ariaDescribedBy.length > 0 ? ariaDescribedBy.join(" ") : undefined
  }, otherProps)));
}); // eslint-disable-next-line max-lines-per-function


var Input = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var id = props.id,
      label = props.label,
      className = props.className,
      type = props.type,
      errorMessage = props.errorMessage,
      helperText = props.helperText,
      iconLeft = props.iconLeft,
      iconRight = props.iconRight,
      required = props.required,
      optional = props.optional,
      size = props.size,
      otherProps = _objectWithoutProperties(props, _excluded2);

  var hasError = !!errorMessage;
  var hasIcon = !!iconLeft || !!iconRight;
  var classes = (0, _classnames["default"])({
    "pds-input-error": hasError,
    "pds-input-small": size === "small"
  });
  var ariaDescribedBy = [];

  if (hasError) {
    ariaDescribedBy.push("error-".concat(id));
  }

  if (helperText) {
    ariaDescribedBy.push("helper-text-".concat(id));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-inputWrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-labeledInput"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: id
  }, label, " ", optional ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "pds-label-optional"
  }, "(Optional)") : "", required ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "pds-label-required",
    "aria-hidden": "true"
  }, "*") : ""), helperText ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-helperText",
    id: "helper-text-".concat(id)
  }, helperText) : "", hasIcon ? /*#__PURE__*/_react["default"].createElement(IconInput, _extends({
    id: id,
    className: className,
    type: type,
    required: required,
    iconLeft: iconLeft,
    iconRight: iconRight,
    hasError: hasError,
    ariaDescribedBy: ariaDescribedBy
  }, otherProps)) : /*#__PURE__*/_react["default"].createElement("input", _extends({
    ref: ref,
    id: id,
    className: classes,
    type: type,
    required: required,
    "aria-invalid": hasError ? "true" : false,
    "aria-describedby": ariaDescribedBy.length > 0 ? ariaDescribedBy.join(" ") : undefined
  }, otherProps))), errorMessage ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "pds-error"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "pds-util-flex-align-center",
    id: "error-".concat(id)
  }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    size: 20,
    name: "alert-circle"
  }), errorMessage)) : ""));
});

Input.defaultProps = {
  type: "text"
};
Input.propTypes = {
  /** The id of the input that is used to connect the label. */
  id: _propTypes["default"].string.isRequired,

  /** The label for the input. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]).isRequired,

  /** The standard `type` attribute for an input. */
  type: _propTypes["default"].string,

  /** The name of the input, which is not required, but is often necessary. */
  name: _propTypes["default"].string,

  /**
   * Displays an error message below the input
   * and styles the input in an error state.
   */
  errorMessage: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),

  /** Adds text, located below the label, that helps a user fill out the input.  */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].string]),

  /**
   * Adds an icon left side of the input.
   * It takes the "name" prop from the Icon component.
   */
  iconLeft: _icon.IconNamePropType,

  /**
   * Adds an icon right side of the input.
   * It takes the "name" prop from the Icon component.
   */
  iconRight: _icon.IconNamePropType,

  /** The size of the input. */
  size: _propTypes["default"].oneOf(["small"]),

  /** The standard `required` attribute for an input. */
  required: _propTypes["default"].bool,

  /** Marks the input as "optional" by adding text to the label. */
  optional: _propTypes["default"].bool,

  /** Extra classes for the input. */
  className: _propTypes["default"].string
};
Input.displayName = "Input";
var _default = Input;
exports["default"] = _default;